module.exports = __webpack_public_path__ + "static/media/84e1d9b2-4a5e-42f7-b7bb-e9edadb46977.0757f14a.woff2";